import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=1c637238"
import script from "./MenuAdd.vue?vue&type=script&lang=js"
export * from "./MenuAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports